// import scss
import 'tcplayer.js/dist/tcplayer.min.css';
import 'scss/app.scss';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
import {loading, checkPregnancyApp} from 'common/util';
import App from 'v-component/app.vue';

import {createApp} from 'vue';
import {setup} from 'common/setup';

function bootstrap() {
    checkPregnancyApp();
    loading.show();
    const app = createApp(App);
    setup(app);
}

bootstrap();
